import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemDescriptionComponent } from '@modules/common/components/item-description/item-description.component';
import { SharedBaseComponent } from '@modules/common/components/shared-base/shared-base.component';
import { StchHighlightTextDirective } from '@modules/common/directives/stch-highlight-text.directive';
import { DateFormatPipe } from '@modules/common/pipes/date-format.pipe';
import { ContactsAppContextDirective } from '@modules/contacts/directives/app-contacts-app-context.directive';
import { Group } from '@modules/contacts/types/group';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { SharedKnotsComponent } from '@modules/knots/components/shared-knots/shared-knots.component';
import { SharedSignupCtaComponent } from '@modules/common/components/shared-signup-cta/shared-signup-cta.component';
import { SharedTagsComponent } from '@modules/tags/components/shared-tags/shared-tags.component';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'stch-group-shared',
  templateUrl: './group-shared.component.html',
  styleUrls: ['../../../common/components/shared-base/shared-base.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ContactsAppContextDirective,
    IconComponent,
    DateFormatPipe,
    SharedTagsComponent,
    SharedKnotsComponent,
    SharedSignupCtaComponent,
    StchHighlightTextDirective,
    ItemDescriptionComponent,
  ],
})
export class GroupSharedComponent extends SharedBaseComponent<Group> {
  protected override stitchType = StitchType.GROUP;

  protected get group(): Group {
    return this.stitchItem?.();
  }
}
